import ShareIcon from '@moda/icons/share-20';
import { Clickable, Divider, Stack, Text, useBreakpoint } from '@moda/om';
import React from 'react';
import { useProductShareV2 } from './useProductShareV2';

import './ProductShareV2Desktop.scss';

enum Mode {
  Resting,
  Copied
}

export const ProductShareV2Desktop = () => {
  const { mode, handleCopy } = useProductShareV2();

  const { matches: isDesktop } = useBreakpoint({ gt: 'sm' });

  if (!isDesktop) return null;

  return (
    <Stack className="ProductShareV2Desktop" space={4}>
      <Divider className="ProductShareV2Desktop__divider" />

      {mode === Mode.Resting && (
        <Clickable aria-label="Copy Link" onClick={handleCopy}>
          <ShareIcon />
        </Clickable>
      )}

      {mode === Mode.Copied && (
        <Stack alignItems="flex-start" direction="horizontal" space={1}>
          <ShareIcon />

          <Text>Link Copied</Text>
        </Stack>
      )}
    </Stack>
  );
};
